import * as React from 'react';
import Wrapper from './Wrapper';

const Drag = Wrapper(props => (
  <svg
    aria-hidden="true"
    focusable="false"
    height={20}
    width={20}
    viewBox="0 0 24 24"
    xmlns="http://www.w3.org/2000/svg"
    fill="#535B64"
    stroke="#535B64"
    {...props}
  >
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M8 22.75a2 2 0 100-4 2 2 0 000 4zM8 5.5a2 2 0 100-4 2 2 0 000 4zM8 14.125a2 2 0 100-4 2 2 0 000 4zM16 22.75a2 2 0 100-4 2 2 0 000 4zM16 5.5a2 2 0 100-4 2 2 0 000 4zM16 14.125a2 2 0 100-4 2 2 0 000 4z"
      fill="current"
      stroke="current"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
  </svg>
));

export default Drag;
